<input type="checkbox" [checked]="ch" [value]="ch" [id]="id"/>
<ng-container *ngIf="!disabled">
  <div class="custom-checkbox" (click)="click()"></div>
</ng-container>

<ng-container *ngIf="disabled">
  <div class="custom-checkbox-disabled"></div>
</ng-container>
